import { useNavigate } from "react-router";
import axios from "../api/axios";
import useAuth from "./useAuth";
import { useAppDispatch } from "../redux/hooks/hook";
import { logOut } from "../redux/features/auth/authSlice";

const useLogout = () => {
    const navigate = useNavigate();
    const { setAuth } = useAuth();
    const dispatch = useAppDispatch()

    const logout = async () => {
        localStorage.removeItem('profileURL');
        localStorage.removeItem('token');
        //localStorage.removeItem('auth0_profile');
        localStorage.removeItem('Name');
        localStorage.setItem('authenticated', false);
        setAuth({});
        dispatch(logOut())

        try {
            await axios.post('/auth/logout', {},
            {
                withCredentials: true
            });

            //navigate(`${process.env.PUBLIC_URL}/login`);

        } catch (err) { 
            //console.error(err);
        } finally {
            navigate(`${process.env.PUBLIC_URL}/login`);
        }
    }

    return logout;
}

export default useLogout